<template>
  <div class="fin-page-title">
    <div ref="pageTitleWrapper" :style="{borderBottom: '1px solid' + $finColors.lightSkyBlue}">

      <v-icon v-if="dark"
              dark
              :style="{ height: wrapperHeight + 'px', lineHeight: wrapperHeight + 'px', top: '-.1em'}"
              class="mr-3">
        {{ icon }}
      </v-icon>
      <v-icon v-else
              :style="{ height: wrapperHeight + 'px', lineHeight: wrapperHeight + 'px', top: '-.1em'}"
              class="fin-color-primary-dark--text mr-3">{{ icon }}
      </v-icon>

      <span v-if="dark"
            :style="{ height: wrapperHeight + 'px', lineHeight: wrapperHeight + 'px',
                      display: 'inline-flex', color: $finColors.paleGrey }"
            v-html="title"/>
      <span v-else
            :style="{ height: wrapperHeight + 'px', lineHeight: wrapperHeight + 'px', display: 'inline-flex' }"
            v-html="title"/>

      <span v-if="$slots.afterTitle">
        <slot name="afterTitle"/>
      </span>
      <div v-if="$slots.actions"
           :style="{ height: wrapperHeight + 'px', lineHeight: wrapperHeight + 'px', display: 'inline-flex', float: 'right' }">
        <slot name="actions"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'fin-page-title',
  props: {
    title: {type: String},
    icon: {type: String},
    dark: {type: Boolean},
  },
  data() {
    return {
      wrapperHeight: 36
    }
  },
  mounted() {
    this.wrapperHeight = this.$refs.pageTitleWrapper.clientHeight
  }
}
</script>

<style lang="scss" scoped>
.fin-page-title {
  font-size: 18px;
  line-height: 1;
  font-weight: 500;

  i {
    font-size: 22px;
  }
}
</style>
